import React, { useMemo } from "react";
import classNames from "classnames";
import * as styles from "./styles.module.scss";
const LearnMoreLink = ({ url, className, inline, inheritText }) => {
    const link = useMemo(() => (React.createElement("a", { href: url, className: classNames(styles.link, { [styles.inheritText]: inheritText }), target: "_blank", rel: "noreferrer" }, "Learn more.")), [inheritText, url]);
    return inline ? (React.createElement("span", { className: classNames(styles.root, className, styles.inline) }, link)) : (React.createElement("div", { className: classNames(styles.root, className) }, link));
};
export default LearnMoreLink;
